///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

export const DollarIcon = ({ fill = "#343434", title = "$", ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...rest}>
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-4 0h16v16H-4z" />
      <g fill={fill}>
        <path d="M3.5 2.3v1.4a2 2 0 000 3.7V9a3.4 3.4 0 010-6.6M7.5 5.6H6.1a2 2 0 00-1.2-1.8V2.3c1.5.4 2.6 1.7 2.6 3.3M3.5 12.7v1.5a3.4 3.4 0 01-2.7-3.3h1.4a2 2 0 001.3 1.8M7.5 10.9c0 1.6-1 2.9-2.6 3.2v-1.4A2 2 0 005 9V7.6C6.4 8 7.5 9.3 7.5 11" />
        <path d="M3.5 15.7H5V.8H3.5z" />
      </g>
    </g>
  </svg>
);

export default DollarIcon;
